import client from './client';
import { IUserLog, getRequestData, formatUserData, IBookLog } from './index';

export default (
    cid: string,
    user: IUserLog,
    book: Omit<IBookLog, 'status'>,
    region: string
) => {
    client.info('redirect to sportsbook', {
        cid,
        context: 'BetPlacePage#Redirect',
        book,
        region,
        ...formatUserData(user),
        ...getRequestData(),
    });
};
